import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale' // 引入element 国际化配置
import zh from '../assets/i18n/zh'
import en from '../assets/i18n/en'
import zht from '../assets/i18n/zht'
import jp from '../assets/i18n/jp'
import kr from '../assets/i18n/kr'
Vue.use(VueI18n)
// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = { zh, en, zht, jp, kr }
const i18n = new VueI18n({
  locale: 'zh', // set locale 默认显示英文
  messages: messages // set locale messages
})
locale.i18n((key, value) => i18n.t(key, value)) // 把element 的语言包挂在到i18n中
// 最后 export default，这一步肯定要写的。
export default i18n
